import { translate } from '@utils/i18n';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
const namespace = 'features.dashboards.inspection_assistant_insights';
const getCategoryClassName = (category) => {
    switch (category) {
        case 'analyze_deficiency_notes':
            return 'red';
        case 'unanswered_questions':
            return 'blue';
        case 'missing_signatures':
            return 'purple';
        case 'missing_deficiency_notes_photos':
            return 'yellow';
        case 'missing_time_entries':
            return 'pink';
        default:
            return 'gray';
    }
};
export default function mapper(inspectionAssistantInsights) {
    const inspectionAssistantInsightsResolved = {
        totalExistingIssues: inspectionAssistantInsights.totalExistingIssues,
        totalOpenIssues: inspectionAssistantInsights.totalOpenIssues,
        averageProcessingTime: inspectionAssistantInsights.averageProcessingTime,
        averageNumberOfResubmissions: inspectionAssistantInsights.averageNumberOfResubmissions,
        topIssueCategories: []
    };
    if (inspectionAssistantInsights.topIssueCategories.length > 0) {
        inspectionAssistantInsightsResolved.topIssueCategories = inspectionAssistantInsights.topIssueCategories.map((category) => {
            return {
                name: translate(`top_issue_categories.issue_types.${category}`, {
                    namespace,
                    defaultValue: snakeToCapitalize(category)
                }),
                variant: getCategoryClassName(category)
            };
        });
    }
    return inspectionAssistantInsightsResolved;
}
